// src/services/visitService.js
import axios from 'axios';

// ✅ On récupère l'URL de base (ex: https://api.insbu.bi)
// On ajoute une valeur par défaut au cas où le .env ne serait pas lu
const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://api.insbu.bi/api';

/**
 * Récupère les statistiques de visites pour le footer
 */
export const getVisitStats = async () => {
    try {
        // Nettoyage de l'URL pour éviter les doubles slashes (//)
        const cleanBaseUrl = BASE_URL.replace(/\/$/, '');
        
        // Requête GET vers https://api.insbu.bi/visits-stats
        const response = await axios.get(`${cleanBaseUrl}/visits-stats`);
        
        // Retourne l'objet { success, total, today, online }
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des stats du footer:", error.message);
        
       
        return { total: 0, today: 0, online: 0 };
    }
};
